import { IMAGE_BASE_URL } from './constants';
import { type ImageSize } from './types';

// For resizable images such as jpg, png, etc.
export const buildResizableImageUrl = (
  src: string,
  size: ImageSize = 'medium',
) => {
  const isUrl = src.startsWith('http');
  const imageUrl = isUrl ? src : addBaseUrl(src);

  return addSizeArgument(imageUrl, size);
};

// For not resizable images such as svg etc.
export const buildNonResizableImageUrl = (src: string) => {
  const isUrl = src.startsWith('http');
  const imageUrl = isUrl ? src : addBaseUrl(src);

  return addSizeArgument(imageUrl, 'original');
};

// As agreed, frontend should always provide the size argument to the image url.
const addSizeArgument = (
  src: string,
  size: 'small' | 'medium' | 'large' | 'original' = 'original',
) => {
  return `${src}?size=${size}`;
};

const addBaseUrl = (path: string) => {
  return `${IMAGE_BASE_URL}/${path}`;
};
